import { useEffect, useRef } from "react";

export function useRevealObserver() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current || document;
    const els = root.querySelectorAll(".reveal, .line-reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  });

  return rootRef;
}
